(() => {
  const MOBILE_MAX_WIDTH = 768;
  let scrollTimer = null;

  function isProductPage() {
    return window.location.pathname.includes('/products/');
  }

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  function findMainProductSection(target) {
    return (
      target.closest('.main-product') ||
      target.closest('.product-details') ||
      document.querySelector('.main-product') ||
      document.querySelector('.product-details')
    );
  }

  function findProductMedia(section) {
    if (!section) return null;

    return (
      section.querySelector('.product__media-wrapper') ||
      section.querySelector('.product-slideshow') ||
      section.querySelector('.product-slideshow__slider') ||
      section.querySelector('[class*="product__media"]')
    );
  }

  function scrollToProductMedia(target) {
    if (!isProductPage()) return;
    if (!isMobile()) return;

    const section = findMainProductSection(target);
    const media = findProductMedia(section);

    if (!media) return;

    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
      const header =
        document.querySelector('.js-sticky-header') ||
        document.querySelector('header');

      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const offset = headerHeight + 8;
      const top = media.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }, 180);
  }

  function isVariantTrigger(target) {
    return !!(
      target.closest('input[type="radio"][name^="options"]') ||
      target.closest('input[type="radio"][name*="option"]') ||
      target.closest('select[name^="options"]') ||
      target.closest('select[name="id"]') ||
      target.closest('[data-option-selector]') ||
      target.closest('.product-option') ||
      target.closest('.variant-picker') ||
      target.closest('.product-form__input')
    );
  }

  document.addEventListener('change', (event) => {
    if (!isVariantTrigger(event.target)) return;
    scrollToProductMedia(event.target);
  });

  document.addEventListener('click', (event) => {
    if (!isVariantTrigger(event.target)) return;
    scrollToProductMedia(event.target);
  });
})();